import Button from "@components/common/Button/Button";
import type { ProfileActionButtonsProps } from "../types";

const ProfileActionButtons: React.FC<ProfileActionButtonsProps> = ({ isEditMode, isUpdating, onEdit, onCancel, t }) => {
	return (
		<div className="px-6 pb-6 flex justify-end gap-4 border-t border-gray-100 pt-4">
			{isEditMode ? (
				<>
					<Button variant="tertiary" disabled={isUpdating} onClick={onCancel} className="w-full">
						{t("psdaCommon.common.buttons.cancel")}
					</Button>
					<Button type="submit" disabled={isUpdating} loading={isUpdating} className="w-full">
						{t("psdaCommon.profile.buttons.save")}
					</Button>
				</>
			) : (
				<Button onClick={onEdit}>{t("psdaCommon.profile.buttons.edit")}</Button>
			)}
		</div>
	);
};

export default ProfileActionButtons;
